function isChildOf(element: HTMLElement, parent: HTMLElement | null): boolean {
  if (!element || !parent) {
    return false;
  }

  return parent.contains(element);
}

export default isChildOf;
